import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CredentialsEntity } from '../models/credentials';

export type CredentialsStoreState = {
  loading: boolean;
  error?: string;
  data?: CredentialsEntity;
};

const initialState: CredentialsStoreState = {
  loading: false,
};

export const credentialsSlice = createSlice({
  name: 'credentials',
  initialState,
  reducers: {
    /* Reset credentails */
    resetCredentials: (state) => {
      state.loading = false;
      state.error = undefined;
      state.data = undefined;
    },

    /* Sign existing data */
    signExistingCredentialsStart: (state) => {
      state.loading = true;
      state.error = undefined;
    },
    signExistingCredentialsSuccess: (state, action: PayloadAction<CredentialsEntity>) => {
      state.loading = false;
      state.error = undefined;
      state.data = action.payload;
    },
    signExistingCredentialsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    /* Refresh credentials */
    refreshCredentialsStart: (state) => {
      state.loading = true;
    },
    refreshCredentialsEnd: (state, action: PayloadAction<CredentialsEntity>) => {
      state.data = action.payload;
      state.loading = false;
    },

    /* Authenticate credentials */
    authenticateCredentialsStart: (state) => {
      state.loading = true;
    },
    authenticateCredentialsEnd: (state, action: PayloadAction<CredentialsEntity>) => {
      state.loading = false;
      state.data = action.payload;
    },

    /* Credentials poller method handlers */
    setCredentialsErrorMessage: (state, action: PayloadAction<string | undefined>) => {
      state.error = action.payload;
    },
    setCredentials: (state, action: PayloadAction<CredentialsEntity>) => {
      state.data = action.payload;
    },

    /* Update credentials */
    updateCredentialsStart: (state) => {
      state.loading = true;
      state.error = undefined;
    },
    updateCredentialsSuccess: (state, action: PayloadAction<CredentialsEntity>) => {
      state.loading = false;
      state.data = action.payload;
    },
    updateCredentialsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    /* Create credentials */
    createCredentialsStart: (state) => {
      state.loading = true;
      state.error = undefined;
    },
    createCredentialsSuccess: (state, action: PayloadAction<CredentialsEntity>) => {
      state.data = action.payload;
      state.loading = false;
      state.error = undefined;
    },
    createCredentialsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    getCredentialsStart: (state) => {
      state.loading = true;
      state.error = undefined;
    },
    getCredentialsSuccess: (state, action: PayloadAction<CredentialsEntity>) => {
      state.data = action.payload;
      state.loading = false;
      state.error = undefined;
    },
  },
});

export const {
  resetCredentials,
  signExistingCredentialsStart,
  signExistingCredentialsSuccess,
  signExistingCredentialsFailure,
  refreshCredentialsStart,
  refreshCredentialsEnd,
  authenticateCredentialsStart,
  authenticateCredentialsEnd,
  setCredentialsErrorMessage,
  setCredentials,
  updateCredentialsStart,
  updateCredentialsSuccess,
  updateCredentialsFailure,
  createCredentialsStart,
  createCredentialsSuccess,
  createCredentialsFailure,
  getCredentialsStart,
  getCredentialsSuccess,
} = credentialsSlice.actions;
